import { extractApiErrorMessage } from '@/api/ai/extract-api-error-message'

/**
 * 适用于 AllAll error.message、Pollo message、轮询 statusRes.error、自有接口 message 等。
 * @param {*} source - Error、字符串、或含 message / error 的响应对象
 * @param {string} fallbackText
 * @returns {string}
 */
export function userFacingGenerationError(source, fallbackText) {
  var fb = fallbackText != null ? String(fallbackText) : ''
  if (source == null || source === '') return fb
  if (typeof source === 'string') {
    var s = source.trim()
    return s || fb
  }
  if (typeof source === 'object') {
    if (source.message != null) {
      var m = String(source.message).trim()
      if (m) return m
    }
    var ext = extractApiErrorMessage(source)
    if (ext) return ext
    if (source.error != null && typeof source.error === 'string') {
      var es = String(source.error).trim()
      if (es) return es
    }
  }
  return fb
}
